import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type SetProductionYearPlanCellsMutationVariables = Types.Exact<{
  input: Types.SetProductionYearPlanCellsInput;
}>;


export type SetProductionYearPlanCellsMutation = { __typename?: 'Mutation', setProductionYearPlanCells: { __typename?: 'ProductionYearPlanPayload', productionYearPlan?: { __typename?: 'ProductionYearPlanStateData', productionYearPlanId: string, siteLocationId: string, isoYear: number, productionPlanId?: string | null, updatedAt: Types.TDateISO, updatedBy: string, items: Array<{ __typename?: 'ProductionYearPlanItemData', productionItemId: string, weeks: Array<{ __typename?: 'ProductionYearPlanWeekData', isoWeek: number, quantity: number }>, plannedLike?: { __typename?: 'ProductionYearPlanLikeData', compProductionItemId: string, percent: number, shiftWeeks: number } | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, conflicts: Array<{ __typename?: 'ProductionYearPlanCellConflictData', productionItemId: string, isoWeek: number }> } };

export type SetProductionYearPlanProductionPlanMutationVariables = Types.Exact<{
  input: Types.SetProductionYearPlanProductionPlanInput;
}>;


export type SetProductionYearPlanProductionPlanMutation = { __typename?: 'Mutation', setProductionYearPlanProductionPlan: { __typename?: 'ProductionYearPlanPayload', productionYearPlan?: { __typename?: 'ProductionYearPlanStateData', productionYearPlanId: string, siteLocationId: string, isoYear: number, productionPlanId?: string | null, updatedAt: Types.TDateISO, updatedBy: string, items: Array<{ __typename?: 'ProductionYearPlanItemData', productionItemId: string, weeks: Array<{ __typename?: 'ProductionYearPlanWeekData', isoWeek: number, quantity: number }>, plannedLike?: { __typename?: 'ProductionYearPlanLikeData', compProductionItemId: string, percent: number, shiftWeeks: number } | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetProductionYearPlanItemMutationVariables = Types.Exact<{
  input: Types.SetProductionYearPlanItemInput;
}>;


export type SetProductionYearPlanItemMutation = { __typename?: 'Mutation', setProductionYearPlanItem: { __typename?: 'ProductionYearPlanPayload', productionYearPlan?: { __typename?: 'ProductionYearPlanStateData', productionYearPlanId: string, siteLocationId: string, isoYear: number, productionPlanId?: string | null, updatedAt: Types.TDateISO, updatedBy: string, items: Array<{ __typename?: 'ProductionYearPlanItemData', productionItemId: string, weeks: Array<{ __typename?: 'ProductionYearPlanWeekData', isoWeek: number, quantity: number }>, plannedLike?: { __typename?: 'ProductionYearPlanLikeData', compProductionItemId: string, percent: number, shiftWeeks: number } | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const SetProductionYearPlanCellsDocument = new TypedDocumentString(`
    mutation SetProductionYearPlanCells($input: SetProductionYearPlanCellsInput!) {
  setProductionYearPlanCells(input: $input) {
    productionYearPlan {
      ...ProductionYearPlanFields
    }
    errors {
      code
      message
    }
    conflicts {
      productionItemId
      isoWeek
    }
  }
}
    fragment ProductionYearPlanFields on ProductionYearPlanStateData {
  productionYearPlanId
  siteLocationId
  isoYear
  productionPlanId
  items {
    productionItemId
    weeks {
      isoWeek
      quantity
    }
    plannedLike {
      compProductionItemId
      percent
      shiftWeeks
    }
  }
  updatedAt
  updatedBy
}`);
export const SetProductionYearPlanProductionPlanDocument = new TypedDocumentString(`
    mutation SetProductionYearPlanProductionPlan($input: SetProductionYearPlanProductionPlanInput!) {
  setProductionYearPlanProductionPlan(input: $input) {
    productionYearPlan {
      ...ProductionYearPlanFields
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionYearPlanFields on ProductionYearPlanStateData {
  productionYearPlanId
  siteLocationId
  isoYear
  productionPlanId
  items {
    productionItemId
    weeks {
      isoWeek
      quantity
    }
    plannedLike {
      compProductionItemId
      percent
      shiftWeeks
    }
  }
  updatedAt
  updatedBy
}`);
export const SetProductionYearPlanItemDocument = new TypedDocumentString(`
    mutation SetProductionYearPlanItem($input: SetProductionYearPlanItemInput!) {
  setProductionYearPlanItem(input: $input) {
    productionYearPlan {
      ...ProductionYearPlanFields
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionYearPlanFields on ProductionYearPlanStateData {
  productionYearPlanId
  siteLocationId
  isoYear
  productionPlanId
  items {
    productionItemId
    weeks {
      isoWeek
      quantity
    }
    plannedLike {
      compProductionItemId
      percent
      shiftWeeks
    }
  }
  updatedAt
  updatedBy
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    SetProductionYearPlanCells: build.mutation<SetProductionYearPlanCellsMutation, SetProductionYearPlanCellsMutationVariables>({
      query: (variables) => ({ document: SetProductionYearPlanCellsDocument, variables })
    }),
    SetProductionYearPlanProductionPlan: build.mutation<SetProductionYearPlanProductionPlanMutation, SetProductionYearPlanProductionPlanMutationVariables>({
      query: (variables) => ({ document: SetProductionYearPlanProductionPlanDocument, variables })
    }),
    SetProductionYearPlanItem: build.mutation<SetProductionYearPlanItemMutation, SetProductionYearPlanItemMutationVariables>({
      query: (variables) => ({ document: SetProductionYearPlanItemDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useSetProductionYearPlanCellsMutation, useSetProductionYearPlanProductionPlanMutation, useSetProductionYearPlanItemMutation } = injectedRtkApi;
